import dayjs from 'dayjs'
import React from 'react'
import {
	DateDisplayText,
	DateDisplayValue,
	DateRangeDisplay,
	DateSelectorContainer,
	DateSeparator,
	DaysCount,
	EditButton,
} from './DateSelector.styles'
import { DateSelectorProps } from './types'

const DateSelector: React.FC<DateSelectorProps> = ({ initialStartDate, initialEndDate, onEditClick }) => {
	// Format dates for human-readable display
	const formatDateDisplay = (date: string): string => {
		if (!date) return 'Not set'
		return dayjs(date).format('MMM D, YYYY')
	}

	// Calculate the number of days
	const calculateDays = (): number => {
		if (!initialStartDate || !initialEndDate) return 0
		const start = dayjs(initialStartDate)
		const end = dayjs(initialEndDate)
		return end.diff(start, 'day') + 1
	}

	const dayCount = calculateDays()

	return (
		<DateSelectorContainer>
			<DateRangeDisplay>
				{dayCount > 0 && (
					<DaysCount>
						{dayCount} {dayCount === 1 ? 'Day' : 'Days'}
					</DaysCount>
				)}

				<DateSeparator>-</DateSeparator>

				<DateDisplayText>
					<DateDisplayValue>{formatDateDisplay(initialStartDate)}</DateDisplayValue>
					<DateSeparator>to</DateSeparator>
					<DateDisplayValue>{formatDateDisplay(initialEndDate)}</DateDisplayValue>
				</DateDisplayText>

				<DateSeparator>-</DateSeparator>

				<EditButton onClick={onEditClick}>Edit Trip Dates</EditButton>
			</DateRangeDisplay>
		</DateSelectorContainer>
	)
}

export default DateSelector
